import { createSlice } from '@reduxjs/toolkit'

const pinSlice = createSlice({
  name: 'pin',
  initialState: {
    newPin: '',
    confirmPin: '',
  },
  reducers: {
    setNewPin: (state, action) => {
      state.newPin = action.payload
    },
    setConfirmPin: (state, action) => {
      state.confirmPin = action.payload
    },
    resetPinState: (state) => {
      state.confirmPin = ''
      state.newPin = ''
    },
  },
})

export const { setNewPin, setConfirmPin, resetPinState } = pinSlice.actions

export default pinSlice.reducer
